import { Component, Host, h, ComponentInterface, Prop } from '@stencil/core';

@Component({
  tag: 'telco-feature-text',
  styleUrl: 'telco-feature-text.scss',
  shadow: false,
  scoped: true
})
export class TelcoFeatureText implements ComponentInterface {
  @Prop() public desc: string;

  render(): any {
    return (
      <Host>
        <div class="feature-text-container">
          <div class="feature-icon">
            <slot />
          </div>
          <div class="feature-desc">{this.desc}</div>
        </div>
      </Host>
    );
  }
}
